import { styled, Box } from '@withjoy/joykit';

export const StyledInfoBlockWrapper = styled(Box)``;
